import { SectionHeading } from '@/components/InvoiceReportDetailDrawer/parts/SectionHeading';
import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';
import { ApplicationDetail } from './ApplicationDetail';

export type ApplicationContentProps = {
  reportId: string;
  initialOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
};

export const ApplicationContent: FC<ApplicationContentProps> = memo(
  ({ reportId, initialOpen, onToggle }) => {
    const { t } = useTranslation();

    return (
      <SectionHeading
        initialOpen={initialOpen}
        title={t('application_content.section_title')}
        onToggle={onToggle}
      >
        <ApplicationDetail reportId={reportId} />
      </SectionHeading>
    );
  }
);

ApplicationContent.displayName = 'AdminInvoiceReportDetailApplicationContent';
